var _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1204_10765)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1204_10765",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1204_10765)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.752 24.5206C19.231 24.4926 18.706 24.3916 18.198 24.1756C15.859 23.1826 14.764 20.4756 15.76 18.1336C16.573 16.2226 18.521 15.1676 20.483 15.3746C20.483 15.3746 22.861 13.9556 23.643 13.3986C23.473 13.3606 23.004 13.3136 22.844 13.2456C21.814 12.8066 21.07 11.7426 20.916 10.5466C20.265 10.4726 19.615 10.4676 18.978 10.5266C18.801 11.7206 18.209 12.4926 17.168 12.9156C16.128 13.3346 15.078 13.3866 14.126 12.6516C13.623 13.0486 13.159 13.5026 12.741 14.0076C13.46 14.9756 13.752 16.0616 13.313 17.0936C12.875 18.1246 11.805 18.8666 10.609 19.0216C10.535 19.6716 10.53 20.3206 10.59 20.9576C11.783 21.1356 12.555 21.7286 12.974 22.7676C13.398 23.8086 13.247 24.7736 12.51 25.7286C12.913 26.2306 13.364 26.6906 13.868 27.1106C14.837 26.3906 16.12 26.1876 17.152 26.6276C18.18 27.0656 18.928 28.1306 19.079 29.3256C19.609 29.3846 20.138 29.3886 20.66 29.3606V25.2496L19.752 24.5206Z",
    fill: "#44A6E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.779 17.2751L25.844 15.3171C25.617 15.1681 25.314 15.2311 25.165 15.4571C25.113 15.5361 25.085 15.6281 25.085 15.7231V20.1271H23.128V15.7241C23.126 15.4541 22.905 15.2361 22.635 15.2381C22.54 15.2381 22.448 15.2661 22.369 15.3191L19.432 17.2771C19.295 17.3671 19.212 17.5191 19.211 17.6821V22.5761C19.212 22.7241 19.28 22.8651 19.398 22.9571L21.659 24.7691V28.8891C21.659 29.1601 21.878 29.3771 22.148 29.3771H26.062C26.333 29.3771 26.552 29.1591 26.552 28.8891V24.7691L28.813 22.9571C28.931 22.8641 29 22.7231 29 22.5751V17.6811C28.999 17.5181 28.917 17.3651 28.779 17.2751Z",
    fill: "#0270B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1204_10765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.989a46f7d48712c1a8d1f5006049a379.svg";
export { ForwardRef as ReactComponent };